import React, { useEffect, useState } from "react";
import { sliderdata } from "./slidedata";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import GooglePlayLogo from "../../../images/GooglePlayLogo";
import "./sectionOne.css";

const Slider2 = () => {
  const [slides] = useState(sliderdata);
  const slideInterval = 10000;
  return (
    <Carousel autoPlay infiniteLoop interval={slideInterval}>
      {slides.map((slide) => {
        return (
          <div key={slide.id} className={"one-info-row2"}>
            <div className="one-column1">
              <h2>{slide.title}</h2>
              <p>{slide.info}</p>
              <GooglePlayLogo
                scale={0.8}
                classname={"one-image"}
                alt="google-play-icon"
              />
            </div>
            <div className="one-column2">
              <img src={slide.image} className="one-gif" alt={slide.boxInfo} />
            </div>
          </div>
        );
      })}
    </Carousel>
  );
};

export default Slider2;
